/** Arabic for Sky's interface: the dock, her settings, the welcome and the farewell. Proposed; pending native aviation review. */
const ar: Record<string, string> = {
  "This deployment holds a key and composes on your behalf. Model: {model}.":
    "يحتفظ هذا النشر بمفتاح ويصوغ الردود نيابةً عنك. النموذج: {model}.",
  "This deployment holds no model key, or this copy is on sample data. Nothing is sent anywhere; she answers from what she can read.":
    "لا يحتفظ هذا النشر بمفتاح نموذج، أو أن هذه النسخة تعمل على بيانات تجريبية. لا يُرسل شيء إلى أي جهة؛ وهي تجيب مما تستطيع قراءته.",
  /* ── the dock ── */
  "Show Sky": "إظهار سكاي",
  "Listening for her name — say “Sky”, or press to bring her back": "تستمع إلى اسمها — قل «سكاي»، أو اضغط لإعادتها",
  "Bring the assistant back": "إعادة المساعدة",
  Sky: "سكاي",
  SKY: "سكاي",
  "Open Sky — she is quiet": "فتح سكاي — هي صامتة",
  "Open Sky": "فتح سكاي",
  "Quiet — she answers when asked and says nothing otherwise": "صامتة — تجيب عند سؤالها ولا تقول شيئًا غير ذلك",
  "Ask her something": "اسألها شيئًا",
  quiet: "صامتة",
  Talk: "المحادثة",
  "Due {n}": "المستحق {n}",
  Reminders: "التذكيرات",
  "Reminders {n}": "التذكيرات {n}",
  Sources: "المصادر",
  Look: "المظهر",
  Voice: "الصوت",
  "Collapse the conversation": "طي المحادثة",
  ready: "جاهزة",
  listening: "تستمع",
  "hmm…": "لحظة…",
  speaking: "تتحدث",
  "reading aloud": "تقرأ بصوت مسموع",
  "in conversation": "في محادثة",
  "reading {title}": "تقرأ {title}",
  Stop: "إيقاف",
  "She is quiet: still working, still writing to the log, just not speaking up":
    "هي صامتة: ما زالت تعمل وتكتب في السجل، لكنها لا تتكلم",
  "Ask her to be quiet — she will answer when asked and say nothing otherwise":
    "اطلب منها الصمت — ستجيب عند سؤالها ولن تقول شيئًا غير ذلك",
  "Quiet ✓": "صامتة ✓",
  "Be quiet": "اصمتي",
  "Hide Sky": "إخفاء سكاي",
  "Put her away — a small tab brings her back": "أخفِها — يعيدها لسان صغير",
  "Close Sky": "إغلاق سكاي",
  "I am Sky. Ask about anything on this site — a work order, an alert, a document, a rule. Ask what is most urgent and she will lead with the worst of it. She reads the platform's records first, and whatever you have connected beyond them. She will lay out options; she will not pick one.":
    "أنا سكاي. اسأل عن أي شيء في هذا المطار — أمر عمل، تنبيه، مستند، قاعدة. اسأل عمّا هو أكثر إلحاحًا وستبدأ بأسوئه. تقرأ سجلات المنصة أولًا، ثم ما وصلته بها من مصادر أخرى. تعرض الخيارات، ولا تختار أحدها.",
  "The microphone could not be opened here — type your question, or press the microphone to try again.":
    "تعذّر فتح الميكروفون هنا — اكتب سؤالك، أو اضغط الميكروفون للمحاولة مجددًا.",
  "Listening again in a moment — say “thanks” when you are done.": "ستستمع مجددًا بعد لحظة — قل «شكرًا» عندما تنتهي.",
  "Stop listening": "إيقاف الاستماع",
  "Listen for my voice": "الاستماع لصوتي",
  "Listening — press to stop and type instead": "تستمع — اضغط للإيقاف والكتابة بدلًا من ذلك",
  "Not listening — press to speak instead of typing": "لا تستمع — اضغط للتحدث بدلًا من الكتابة",
  "This browser has no speech recognition, so instructions are typed. She suggests and prepares; every action is still yours to press.":
    "لا يدعم هذا المتصفح التعرف على الكلام، لذا تُكتب التعليمات. هي تقترح وتُعدّ؛ وكل إجراء يبقى لك أن تضغطه.",
  "Just speak — she is listening and answers what she hears. Type instead if you would rather; the microphone button turns listening off.":
    "تحدّث فقط — هي تستمع وتجيب عمّا تسمعه. اكتب إن فضّلت ذلك؛ زر الميكروفون يوقف الاستماع.",
  "Listening is off: type your question. The microphone button turns it back on.":
    "الاستماع متوقف: اكتب سؤالك. زر الميكروفون يعيد تشغيله.",
  "What follows": "ما يترتب على ذلك",
  "Read aloud": "قراءة بصوت مسموع",
  "Full report below.": "التقرير الكامل أدناه.",
  "Draft discarded.": "تم تجاهل المسودة.",
  "{title} — raised by you.": "{title} — أنشأته أنت.",
  "prepared, not raised": "مُعدّ، لم يُنشأ",
  "Creating…": "جارٍ الإنشاء…",
  Discard: "تجاهل",
  "Did not go through: {error}": "لم يتم: {error}",

  /* ── reminders and what is running out ── */
  "Notes to yourself, held in this browser under your sign-in. They do not follow you to another terminal and the platform never sees them — for anything that has to survive the shift, create a new work order instead.":
    "ملاحظات لنفسك، محفوظة في هذا المتصفح باسم دخولك. لا تنتقل معك إلى جهاز آخر ولا تراها المنصة أبدًا — لأي شيء يجب أن يبقى بعد نهاية المناوبة، أنشئ أمر عمل بدلًا من ذلك.",
  "Nothing set.": "لا شيء محدد.",
  done: "تم",
  "Remind me to": "ذكّريني بـ",
  When: "متى",
  "re-check A2 friction": "إعادة فحص الاحتكاك في A2",
  "in 2 hours · 14:30 · tomorrow": "بعد ساعتين · 14:30 · غدًا",
  "Understood as: {said}.": "فُهم على أنه: {said}.",
  "Not understood. Try “in 90 minutes”, “14:30”, “tomorrow”, or “end of shift”.":
    "لم يُفهم. جرّب «in 90 minutes» أو «14:30» أو «tomorrow» أو «end of shift».",
  "“in 90 minutes”, “14:30”, “tomorrow”, “later”, “end of shift”.":
    "«in 90 minutes»، «14:30»، «tomorrow»، «later»، «end of shift».",
  "Set reminder": "ضبط التذكير",
  "Nothing is inside thirty days that you have not already seen. She checks certificates, document reviews and work that is due — only the ones your access lets you read — and warns at thirty days, fifteen, seven, and once more if the date passes.":
    "لا شيء خلال ثلاثين يومًا لم تره بعد. تتحقق من الشهادات ومراجعات المستندات والأعمال المستحقة — ما يسمح لك مستوى وصولك بقراءته فقط — وتنبّه قبل ثلاثين يومًا وخمسة عشر وسبعة، ومرة أخرى إذا فات الموعد.",
  "Warned at thirty days, fifteen and seven, and again once the date passes. “Later” answers this warning; the next one still comes. “Stop” ends them for that item.":
    "يُنبَّه قبل ثلاثين يومًا وخمسة عشر وسبعة، ومرة أخرى بعد فوات الموعد. «لاحقًا» تردّ على هذا التنبيه، ويبقى التالي قادمًا. «إيقاف» ينهيها لهذا البند.",
  Later: "لاحقًا",
  "Never warn about this again": "عدم التنبيه بشأن هذا مجددًا",

  /* ── the look ── */
  "Yours alone — stored against your sign-in in this browser, not for anyone else who uses this terminal. The default is the mark the platform ships with.":
    "خاص بك وحدك — محفوظ باسم دخولك في هذا المتصفح، لا لغيرك ممن يستخدم هذا الجهاز. الافتراضي هو الشعار الذي تأتي به المنصة.",
  Mark: "الشعار",
  Her: "هي",
  "A drawn presence: she blinks, follows your pointer, and her lips move while she speaks.":
    "حضور مرسوم: ترمش، وتتبع مؤشرك، وتتحرك شفتاها وهي تتحدث.",
  Pulse: "نبض",
  "An abstract mark. A core that breathes, three points, a travelling arc.":
    "شعار مجرد. نواة تتنفس، وثلاث نقاط، وقوس متحرك.",
  Orbit: "مدار",
  "The same mark with the three points circling instead of holding.": "الشعار نفسه، والنقاط الثلاث تدور بدل أن تثبت.",
  Arc: "قوس",
  "Ring and arc only — the quietest of the three.": "حلقة وقوس فقط — أهدأ الثلاثة.",
  "Your own image": "صورتك الخاصة",
  "A photograph, in the same 3 × 2 card with the blue field and the grid. It cannot move its lips.":
    "صورة، في البطاقة نفسها بمقاس 3 × 2 مع الخلفية الزرقاء والشبكة. لا تستطيع تحريك شفتيها.",
  Image: "الصورة",
  "Choose an image": "اختيار صورة",
  "Resizing…": "جارٍ تغيير الحجم…",
  "Loaded — {kb} KB after resizing.": "تم التحميل — {kb} KB بعد تغيير الحجم.",
  "JPEG or PNG, landscape 3:2 — 864 × 576 is ideal. Any size is accepted and resized to fit. HEIC, which is what an iPhone saves by default, is not something a browser can read: export as JPEG first.":
    "JPEG أو PNG، أفقية بنسبة 3:2 — والمقاس المثالي 864 × 576. يُقبل أي مقاس ويُعدَّل ليناسب. صيغة HEIC، التي يحفظ بها iPhone افتراضيًا، لا يستطيع المتصفح قراءتها: صدّرها بصيغة JPEG أولًا.",
  "Remove image": "إزالة الصورة",
  "Greet me when I arrive": "رحّبي بي عند وصولي",
  "Keep quiet unless I ask": "ابقي صامتة ما لم أسأل",
  "Quiet stops the badge, the reading aloud and anything arriving while you work. She still writes what she works out to the log, so nothing said in the quiet is lost — open the panel and it is there.":
    "الصمت يوقف الشارة والقراءة بصوت مسموع وكل ما يصل أثناء عملك. تظل تكتب ما تتوصل إليه في السجل، فلا يضيع شيء قيل في الصمت — افتح اللوحة تجده هناك.",
  "Back to the default": "العودة إلى الافتراضي",

  /* ── voice and listening ── */
  "She greets you and says goodbye out loud, and is otherwise silent unless you press “Read aloud” on an answer or turn on the running commentary below. A workstation that narrates itself all shift is a fault, not a feature.":
    "ترحّب بك وتودّعك بصوت مسموع، وتصمت فيما عدا ذلك ما لم تضغط «قراءة بصوت مسموع» على إجابة أو تشغّل التعليق المستمر أدناه. محطة عمل تروي نفسها طوال المناوبة عطل، لا ميزة.",
  "This browser has no speech synthesis, so nothing here will work in it.":
    "لا يدعم هذا المتصفح تحويل النص إلى كلام، لذا لن يعمل فيه شيء هنا.",
  "The browser supports speech but this machine has no voices installed. They come from the operating system, not from here.":
    "يدعم المتصفح الكلام لكن لا أصوات مثبتة على هذا الجهاز. تأتي الأصوات من نظام التشغيل، لا من هنا.",
  "Listen while she is open, and answer what she hears": "الاستماع وهي مفتوحة، والإجابة عمّا تسمعه",
  "On: speak and she answers, with nothing to press. Off: the typing box only. Either way she stops listening when you close her, go quiet, or say “thanks”.":
    "تشغيل: تحدّث وتجيبك دون ضغط أي شيء. إيقاف: مربع الكتابة فقط. وفي الحالتين تتوقف عن الاستماع عندما تغلقها، أو تطلب الصمت، أو تقول «شكرًا».",
  "Listen for my voice while she is away": "الاستماع لصوتي وهي غائبة",
  "Say “assistant” and she comes back and takes the instruction. This keeps the microphone open: the browser asks once, shows a recording indicator the whole time, and in Chrome the audio is sent away to be transcribed. The tab in the corner shows a dot while it is listening.":
    "قل «assistant» فتعود وتتلقى التعليمات. يُبقي هذا الميكروفون مفتوحًا: يطلب المتصفح الإذن مرة واحدة، ويعرض مؤشر تسجيل طوال الوقت، وفي Chrome يُرسل الصوت إلى الخارج لتحويله إلى نص. يُظهر اللسان في الزاوية نقطة أثناء الاستماع.",
  "This browser has no speech recognition, so she cannot listen for her name in it.":
    "لا يدعم هذا المتصفح التعرف على الكلام، لذا لا تستطيع الاستماع إلى اسمها فيه.",
  "Say hello and goodbye out loud": "الترحيب والوداع بصوت مسموع",
  "Two sentences, at the start and end of a shift. Both follow a press — entering the platform, or signing out — which is also what lets the browser make a sound at all.":
    "جملتان، في بداية المناوبة ونهايتها. كلتاهما تلي ضغطة — دخول المنصة أو تسجيل الخروج — وهذا أيضًا ما يسمح للمتصفح بإصدار صوت أصلًا.",
  "Read every answer aloud as it arrives": "قراءة كل إجابة بصوت مسموع عند وصولها",
  "Whatever this says, a question asked out loud is answered out loud — otherwise hands-free is you talking and her writing back. This setting is about the ones you type. While she is reading, say “stop” and she stops.":
    "أيًّا كان هذا الإعداد، فالسؤال المنطوق يُجاب عنه بصوت مسموع — وإلا لكان الاستخدام دون يدين أن تتكلم أنت وتكتب هي. هذا الإعداد يخص الأسئلة المكتوبة. وأثناء قراءتها، قل «stop» فتتوقف.",
  "System default": "افتراضي النظام",
  "{n} installed on this machine.|{n} installed on this machine.":
    "لا أصوات مثبتة على هذا الجهاز.|صوت واحد مثبت على هذا الجهاز.|صوتان مثبتان على هذا الجهاز.|{n} أصوات مثبتة على هذا الجهاز.|{n} صوتًا مثبتًا على هذا الجهاز.|{n} صوت مثبت على هذا الجهاز.",
  "Voices come from the operating system.": "تأتي الأصوات من نظام التشغيل.",
  Hears: "تسمع",
  "Follow the voice above": "اتباع الصوت أعلاه",
  "What the microphone is transcribed as — a different question from how she sounds. It was fixed at British English regardless of who was speaking.":
    "اللغة التي يُحوَّل بها صوت الميكروفون إلى نص — وهي مسألة مختلفة عن صوتها. كانت مثبتة على الإنجليزية البريطانية أيًّا كان المتحدث.",
  "Rate · {rate}×": "السرعة · {rate}×",
  "Hear it": "استمع إليه",

  /* ── beyond the platform ── */
  "She always reads this platform's own records. Everything below is optional and adds reach beyond them. Keys are held in this browser only — the same honesty the sign-in gate gives you: it stops someone using the screen, it does not protect the data.":
    "تقرأ دائمًا سجلات هذه المنصة. كل ما أدناه اختياري ويوسّع وصولها خارجها. تُحفظ المفاتيح في هذا المتصفح فقط — بالصراحة نفسها التي تقدمها بوابة الدخول: تمنع أحدًا من استخدام الشاشة، ولا تحمي البيانات.",
  "Language model": "النموذج اللغوي",
  "Claude · Anthropic": "Claude · Anthropic",
  "ChatGPT · OpenAI": "ChatGPT · OpenAI",
  "Gemini · Google": "Gemini · Google",
  "On this machine · Ollama or LM Studio": "على هذا الجهاز · Ollama أو LM Studio",
  "Something else, OpenAI-compatible": "خيار آخر متوافق مع OpenAI",
  "Keys are made at console.anthropic.com. Calling it straight from a page needs the direct-browser-access header, which this sends. Check the model name in the console — a wrong one returns a 404, not a wrong answer.":
    "تُنشأ المفاتيح في console.anthropic.com. استدعاؤه مباشرة من صفحة يتطلب ترويسة direct-browser-access، وهذا يرسلها. تحقق من اسم النموذج في وحدة التحكم — الاسم الخاطئ يعيد 404، لا إجابة خاطئة.",
  "Any OpenAI-compatible gateway works here too — Azure OpenAI, OpenRouter, Together, Groq — give it that gateway's URL.":
    "تعمل هنا أيضًا أي بوابة متوافقة مع OpenAI — Azure OpenAI وOpenRouter وTogether وGroq — أعطها عنوان URL لتلك البوابة.",
  "The model name goes in the URL, so it has to be one Google currently serves.":
    "يُوضع اسم النموذج في عنوان URL، لذا يجب أن يكون نموذجًا تقدمه Google حاليًا.",
  "Nothing leaves the machine. Ollama must be started with OLLAMA_ORIGINS=* or the browser refuses the call — and that refusal looks exactly like the model being down.":
    "لا يغادر شيء الجهاز. يجب تشغيل Ollama مع OLLAMA_ORIGINS=* وإلا رفض المتصفح الاستدعاء — وهذا الرفض يبدو تمامًا كأن النموذج متوقف.",
  "Anything that speaks /v1/chat/completions.": "أي خدمة تتعامل مع /v1/chat/completions.",
  "Anthropic API key": "مفتاح Anthropic API",
  "OpenAI API key": "مفتاح OpenAI API",
  "Google AI Studio key": "مفتاح Google AI Studio",
  "Key, if your server wants one": "المفتاح، إن طلبه خادمك",
  "Key, if the endpoint needs one": "المفتاح، إن احتاجته نقطة الاتصال",
  "usually blank": "عادةً فارغ",
  "paste the key": "الصق المفتاح",
  Endpoint: "نقطة الاتصال",
  Model: "النموذج",
  "Web search": "البحث على الويب",
  Serper: "Serper",
  Tavily: "Tavily",
  Brave: "Brave",
  "Google results over a plain API key.": "نتائج Google عبر مفتاح API بسيط.",
  "Search built for retrieval rather than for people.": "بحث مصمم للاسترجاع الآلي لا للأشخاص.",
  "Some plans refuse browser-origin calls; that failure arrives as a CORS error.":
    "بعض الخطط ترفض الاستدعاءات الصادرة من المتصفح؛ ويظهر هذا الإخفاق كخطأ CORS.",
  "serper.dev key": "مفتاح serper.dev",
  "Tavily key": "مفتاح Tavily",
  "Brave Search key": "مفتاح Brave Search",
  "Search key": "مفتاح البحث",
  optional: "اختياري",
  "A model is connected. She will say when an answer came from it.": "نموذج متصل. ستذكر متى جاءت الإجابة منه.",
  "No model connected — she will answer from platform records and say so.":
    "لا نموذج متصل — ستجيب من سجلات المنصة وتذكر ذلك.",

  /* ── access level ── */
  "Sky reads, says and opens only what is at or below this level. Screens above it are not listed and not opened, and a question about what is on them — or what anyone is deciding or working on there — is refused by level, never answered.":
    "لا تقرأ سكاي ولا تقول ولا تفتح إلا ما هو عند هذا المستوى أو دونه. الشاشات الأعلى منه لا تُدرج ولا تُفتح، والسؤال عمّا فيها — أو عمّا يقرره أحد أو يعمل عليه هناك — يُرفض بحكم المستوى، ولا يُجاب عنه أبدًا.",
  "The platform granted": "منحت المنصة",
  "from the roles {name} holds. It can be lowered here and not raised: a client that could widen its own access would not be access control. To change what is granted, change the person’s roles on the platform.":
    "بناءً على الأدوار التي يشغلها {name}. يمكن خفضه هنا لا رفعه: فالعميل الذي يستطيع توسيع وصوله بنفسه لا يكون ضبطًا للوصول. لتغيير ما مُنح، غيّر أدوار الشخص على المنصة.",
  "This level was not issued by a platform.": "لم تُصدر هذا المستوى أي منصة.",
  "This is the built-in sample, which shows the whole platform.":
    "هذه البيانات التجريبية المدمجة، وهي تعرض المنصة كاملة.",
  "The platform did not return one, so the sign-in's groups were read instead — a reading, not a grant.":
    "لم تُرجع المنصة مستوى، لذا قُرئت مجموعات تسجيل الدخول بدلًا منه — قراءة، لا منح.",
  "It can still be lowered here.": "لا يزال بالإمكان خفضه هنا.",
  "level in force": "المستوى النافذ",
  "access level": "مستوى الوصول",
  "as granted": "كما مُنح",
  "as the sign-in implies": "كما يقتضي تسجيل الدخول",
  "lower than granted": "أدنى مما مُنح",
  Master: "كامل",
  "the airport in operation: the dashboard, work orders, inspections, alerts, the map, the library":
    "المطار أثناء التشغيل: لوحة المعلومات، وأوامر العمل، والفحوصات، والتنبيهات، والخريطة، والمكتبة",
  "operations, plus the engines: reliability, drift, the programme, what-if, liability, the ledger, capacity, testing, projects":
    "التشغيلي، ومعه المحركات: الموثوقية، والانحراف، والبرنامج، وماذا لو، والمسؤولية، ودفتر الأستاذ، والسعة، والاختبارات، والمشاريع",
  "engineering, plus the chief executive's desks: the Decision Room, crisis, cash, expansion, capital, the regulator, benchmark, improvement, green":
    "الهندسي، ومعه مكاتب الرئيس التنفيذي: غرفة القرار، والأزمة، والنقد، والتوسعة، ورأس المال، والجهة التنظيمية، والمقارنة المعيارية، والتحسين، والاستدامة",
  "everything, including the settings that grant access": "كل شيء، بما في ذلك الإعدادات التي تمنح الوصول",

  /* ── what she has learned ── */
  "Every question and which of her layers answered it; the screens she was taught by where you went next when she had no answer; and the questions still unanswered — the list to widen her guide or the platform's catalog from.":
    "كل سؤال وأي طبقة من طبقاتها أجابت عنه؛ والشاشات التي تعلّمتها من حيث ذهبت بعد ذلك حين لم تكن لديها إجابة؛ والأسئلة التي لم يُجب عنها بعد — القائمة التي يُوسَّع منها دليلها أو فهرس المنصة.",
  "{asked} asked · {answered} answered · {taught} routes taught · {unanswered} still unanswered":
    "{asked} سؤالًا · {answered} أُجيب عنها · {taught} مسارًا متعلَّمًا · {unanswered} دون إجابة بعد",
  "open the screen that answers it and she will remember": "افتح الشاشة التي تجيب عنه وستتذكر",
  "Forget what she has learned": "محو ما تعلّمته",

  /* ── her mark ── */
  "Sky, ready": "سكاي، جاهزة",
  "Sky, listening": "سكاي، تستمع",
  "Sky, working": "سكاي، تعمل",
  "Sky, speaking": "سكاي، تتحدث",

  /* ── the welcome and the farewell ── */
  "Sky greeting": "ترحيب سكاي",
  "Hide the detail": "إخفاء التفاصيل",
  "Show what is open": "إظهار المفتوح",
  "{n} due": "{n} مستحقة",
  "{n} open": "{n} مفتوحة",
  More: "المزيد",
  "How can I help you today?": "كيف أستطيع مساعدتك اليوم؟",
  "I am Sky. I read this platform's records, I can raise work and plan it, and I can explain any screen or field — ask me for a tutorial. I never decide anything; that stays yours.":
    "أنا سكاي. أقرأ سجلات هذه المنصة، وأستطيع إنشاء الأعمال وتخطيطها، وشرح أي شاشة أو حقل — اطلب مني درسًا تعليميًا. لا أقرر شيئًا أبدًا؛ فالقرار يبقى لك.",
  "You were last here {when}.": "كانت آخر زيارة لك {when}.",
  "Worst open now:": "الأسوأ المفتوح الآن:",
  "Running out:": "يقترب موعده:",
  "and {n} more, under Due.": "و{n} أخرى، ضمن المستحق.",
  "Since you were last here:": "منذ آخر زيارة لك:",
  "This session is on the built-in sample, so none of the above is real.":
    "هذه الجلسة على البيانات التجريبية المدمجة، لذا لا شيء مما سبق حقيقي.",
  "What should I look at?": "بمَ أبدأ؟",
  Start: "ابدأ",
  "You are signed out. The figures above were read at {stamp}, not now.":
    "تم تسجيل خروجك. قُرئت الأرقام أعلاه في {stamp}، لا الآن.",
  /* ── walkthroughs: the caption, its controls and its titles ── */
  "I would enter: {value}": "كنت سأُدخل: {value}",
  "{i} of {n}": "{i} من {n}",
  "Previous step (←)": "الخطوة السابقة (←)",
  "Pause or resume (space)": "إيقاف مؤقت أو متابعة (مسافة)",
  Resume: "متابعة",
  Pause: "إيقاف مؤقت",
  "Read the steps aloud": "قراءة الخطوات بصوت مسموع",
  "Stop reading aloud": "إيقاف القراءة بصوت مسموع",
  "Sound on": "تشغيل الصوت",
  Mute: "كتم",
  "Next step (→)": "الخطوة التالية (→)",
  Finish: "إنهاء",
  "End the walkthrough": "إنهاء الجولة",
  "End the walkthrough (Esc)": "إنهاء الجولة (Esc)",
  "I could not find that on this screen just now, so I am telling you instead of pointing.":
    "لم أجد ذلك على هذه الشاشة الآن، لذا أخبرك به بدلًا من الإشارة إليه.",
  "That one changes a record, so it is yours to press — I am only pointing at it.":
    "هذا الزر يغيّر سجلًا، لذا الضغط عليه قرارك — أنا أشير إليه فقط.",
  Welcome: "مرحبًا",
  "Search and tools": "البحث والأدوات",
  "How to": "طريقة العمل",
  "Here it is": "ها هو",
  "Where it is": "أين يوجد",
  "The quick tour": "الجولة السريعة",
  "The full tour": "الجولة الكاملة",
  "This screen": "هذه الشاشة",
  "The critical items": "البنود الحرجة",
  "One finding": "ملاحظة واحدة",
  "A screen": "شاشة",
  "Show me around this screen": "عرّفني على هذه الشاشة",
  "Give me the tour": "خذني في جولة",
  "Take the full tour": "الجولة الكاملة",
  "Review the critical items": "مراجعة البنود الحرجة",
  "Walk me through them": "اشرحها لي واحدًا واحدًا",
  "List them": "اعرضها في قائمة",
  "Show me item 1": "أرني البند 1",
  /* on a call (CallView) */
  "Let me check…": "دعني أتحقق…",
  "The microphone could not be opened here. Press Type instead, or try the microphone again.":
    "تعذّر فتح الميكروفون هنا. اضغط «اكتب بدلًا من ذلك»، أو جرّب الميكروفون مرة أخرى.",
  "Say “Sky” when you want me.": "قل «سكاي» عندما تحتاجني.",
  "Sky on a call": "سكاي في محادثة",
  "How can I help you?": "كيف يمكنني مساعدتك؟",
  "Type to Sky…": "اكتب إلى سكاي…",
  "Type to Sky": "اكتب إلى سكاي",
  Send: "إرسال",
  "Type instead": "اكتب بدلًا من ذلك",
  "Talk instead": "تحدّث بدلًا من ذلك",
  Listen: "استمع",
  "Copy voice log": "نسخ سجل الصوت",
  "Voice log copied": "نُسخ سجل الصوت",
};
export default ar;
